import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import { getUserById } from 'modules/userModule/request/userRequest';
import moment from 'moment';

const Home = (): JSX.Element => {
  const [user, setUser] = useState<null | {
    name: string;
    lastPasswordChange: string;
  }>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getUserById(JSON.parse(token).userId).then((response) => {
        setUser(response);
      });
    }
  }, []);

  if (!user) {
    return <></>;
  }

  const now = moment();
  const change = moment(user.lastPasswordChange);
  const daysLeft = 30 - now.diff(change, 'days');

  return (
    <>
      <Bread>
        <Breadcrumb.Item>
          <HomeOutlined />
        </Breadcrumb.Item>
      </Bread>
      <div className="site-layout-background">
        Zalogowany uzytkownik: <b>{user.name}</b>
        <br />
        Twoja ostatnia zmiana hasła:{' '}
        <b>
          {moment(user.lastPasswordChange).format('DD.MM.YYYY HH:mm:ss')}.
        </b>{' '}
        Pozostało Ci <b>{daysLeft}</b> dni do zmiany hasła.
      </div>
    </>
  );
};

export default Home;
